import { ApolloError } from '@apollo/client'

/**
 * The message to show for a failed GraphQL call. The conversation refresh
 * mutations put a plain-English message in the first GraphQL error, so that
 * is preferred over Apollo's own message, which for a network failure is all
 * there is. Anything that is not an Error gets `fallback`, rather than
 * "[object Object]".
 */
export function graphqlErrorMessage(err: unknown, fallback: string): string {
    let message: string | undefined
    if (err instanceof ApolloError) message = err.graphQLErrors[0]?.message ?? err.message
    else if (err instanceof Error) message = err.message
    // Apollo 2 prefixed messages with this, and some links still do.
    message = message?.replace(/^GraphQL error: /, '').trim()
    return message || fallback
}
